<template>
  <div id="IndexForseti_div">
    <div v-if="$route.fullPath != '/Forseti/TransmisionEnVivo/Audiencia'">
      <menusuperior titulo="FORSETI" subtitulo="Manejo, control y consulta de audiencias"></menusuperior>
      <menuizquierda ></menuizquierda>
    </div>

    <div class="content-area" v-if="$route.fullPath != '/Forseti/TransmisionEnVivo/Audiencia'" >
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>
    <div v-else>
      <transition name="fade" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>
 
  </div>
</template>
<script>
  import menusuperior from '@/components/Comunes/MenuSuperior.vue'
  import menuizquierda from '@/components/Comunes/MenuIzquierdaDeLosSistemas.vue'
  import comun from '@/../static/js/comun'

  export default {
    name: 'Plantilla',
    components: {
      menusuperior: menusuperior,
      menuizquierda: menuizquierda
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Comun/Plantilla.vue